import React from 'react';
import propTypes from './propTypes';
import Cannabis from './Cannabis';

const OtherCrop = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <Cannabis
    className={className}
    notUseClass={notUseClass}
    style={style}
  />
);

OtherCrop.propTypes = propTypes;

export default OtherCrop;
